export default {
  actionType: {
    navigate: 'ページ遷移',
    scan: 'スキャン操作',
    dialog: 'ポップアップ表示',
    custom: 'カスタムリンク',
  },
  end: {
    member: '会員センター',
    mall: 'ポイントモール',
    h5Scan: 'H5スキャン',
  },
  link: {
    home: 'ホーム',
    scan: 'スキャン検証',
    myGifts: 'マイギフト',
    myPointOrders: 'ポイント注文',
    afterSale: 'アフターサービス',
    growth: '成長値明細',
    benefits: '会員特典',
    login: 'ログイン',
  },
  guard: {
    login: 'ログインが必要',
  },
  extra: {
    params: 'パラメータ',
    dialogTitle: 'ポップアップタイトル',
    dialogContent: 'ポップアップ内容',
  },
};
